import React from 'react';
import styled from 'styled-components';

function CounterFillBar({ fillPercentage, barColorTheme }) {
  return (
    <>
      <EntriesProgress barTheme={barColorTheme} percentage={fillPercentage} />
      <EntriesProgressBorder barTheme={barColorTheme} percentage={fillPercentage} />
    </>
  );
}

export default CounterFillBar;

const EntriesProgress = styled.div`
  position: absolute;
  display: ${({ percentage }) => `${percentage > 0 ? 'auto' : 'none'}`};
  left: 1px;
  top: 1px;
  height: calc(100% - 2px);
  border-radius: 1.5rem;
  z-index: 3;
  background: ${({ barTheme }) =>
    `linear-gradient(to bottom, ${barTheme.barFillColor[0]}, ${barTheme.barFillColor[1]})`};
  width: ${({ percentage }) => (percentage > 0 ? `calc(${percentage}% - 2px)` : 0)};
`;

const EntriesProgressBorder = styled.div`
  position: absolute;
  display: ${({ percentage }) => `${percentage > 0 ? 'auto' : 'none'}`};
  left: 0px;
  top: 0px;
  height: 100%;
  z-index: 2;
  border-radius: 1.5rem;
  background: ${({ barTheme }) =>
    `linear-gradient(to bottom, ${barTheme.barFillBorderColor[0]}, ${barTheme.barFillBorderColor[1]})`};
  width: ${({ percentage }) => `${percentage ?? 0}%`};
`;
